import React from "react";
import ReactDOM from "react-dom";
import { App } from '@app/index';

ReactDOM.render(<App />, document.getElementById("root") as HTMLElement);
